/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Badge } from './ui/badge';
import { Textarea } from './ui/textarea';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { 
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter 
} from './ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Switch } from './ui/switch';
import {
  Package, Plus, Edit3, Trash2, Copy, Users, CreditCard, Wallet, Coins,
  TrendingUp, Shield, Building, Briefcase, Eye, UserPlus, Check, X,
  Loader2, Search, Filter, BarChart3, Settings, Zap, Star, Crown,
  ChevronRight, ArrowRight, Sparkles, Target, Award, Clock, Calendar,
  PieChart, Activity, Info, AlertCircle, CheckCircle2, RefreshCw, ShoppingCart, Receipt
} from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';
import StripeCheckoutButton from './StripeCheckoutButton';
import { getToken, getAuthHeader as getStoredAuthHeader } from '../services/tokenService';
import InstitutionalHero from './ui/InstitutionalHero';


export const GestionPlansAnalyticsTab = ({ ctx }) => {
  const {
    activeTab, assignForm, assignPlanSearch, assignUserSearch, assignmentSearch,
    assignmentStatusFilter, assignments, dialogStep, editingPlan, filterRole, filterType,
    loading, planForm, plans, saving, searchTerm, selectedPlan, selectedPlanIds,
    showAssignDialog, showDetailDialog, showPlanDialog, users,
    setActiveTab, setAssignForm, setAssignPlanSearch, setAssignUserSearch, setAssignmentSearch,
    setAssignmentStatusFilter, setAssignments, setDialogStep, setEditingPlan, setFilterRole,
    setFilterType, setLoading, setPlanForm, setPlans, setSaving, setSearchTerm, setSelectedPlan,
    setSelectedPlanIds, setShowAssignDialog, setShowDetailDialog, setShowPlanDialog, setUsers,
    fetchAssignments, fetchPlans, fetchUsers, filteredPlans, getAuthHeader, getPricingTypeConfig,
    getRoleConfig, handleAssignPlan, handleBulkDeletePlans, handleBulkToggleActive, handleDeletePlan,
    handleDuplicatePlan, handleSavePlan, openCreateDialog, openDetailDialog, openEditDialog,
    renderPlanPrice, stats, togglePlanSelection, toggleSelectAllPlans,
    PRICING_TYPES, TARGET_ROLES, DEFAULT_PLAN, PLAN_COLORS, getErrorMessage,
  } = ctx;
  return (
        <TabsContent value="analytics" className="space-y-6">
          {/* Bandeau KPI hero */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <Card className="kpi-rise kpi-rise-0 relative overflow-hidden border-0 shadow-lg">
              <div className="absolute inset-0 bg-gradient-to-br from-purple-600 to-indigo-700" />
              <CardContent className="relative p-5">
                <div className="flex items-center justify-between mb-2">
                  <div className="p-2 rounded-lg bg-white/20 backdrop-blur">
                    <Package className="w-5 h-5 text-white" />
                  </div>
                  <Badge className="bg-slate-900/70 text-white border border-white/30 text-[10px] font-bold tracking-wider px-2 py-0.5">TOTAL</Badge>
                </div>
                <div className="text-3xl font-bold text-white">{stats.totalPlans}</div>
                <div className="text-xs text-purple-100 mt-1">Plans créés</div>
              </CardContent>
            </Card>

            <Card className="kpi-rise kpi-rise-1 relative overflow-hidden border-0 shadow-lg">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-500 to-teal-600" />
              <CardContent className="relative p-5">
                <div className="flex items-center justify-between mb-2">
                  <div className="p-2 rounded-lg bg-white/20 backdrop-blur">
                    <CheckCircle2 className="w-5 h-5 text-white" />
                  </div>
                  <Badge className="bg-slate-900/70 text-white border border-white/30 text-[10px] font-bold tracking-wider px-2 py-0.5">
                    {stats.totalPlans > 0 ? Math.round((stats.activePlans / stats.totalPlans) * 100) : 0}%
                  </Badge>
                </div>
                <div className="text-3xl font-bold text-white">{stats.activePlans}</div>
                <div className="text-xs text-emerald-100 mt-1">Plans actifs</div>
              </CardContent>
            </Card>

            <Card className="kpi-rise kpi-rise-2 relative overflow-hidden border-0 shadow-lg">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-cyan-600" />
              <CardContent className="relative p-5">
                <div className="flex items-center justify-between mb-2">
                  <div className="p-2 rounded-lg bg-white/20 backdrop-blur">
                    <Users className="w-5 h-5 text-white" />
                  </div>
                  <Badge className="bg-slate-900/70 text-white border border-white/30 text-[10px] font-bold tracking-wider px-2 py-0.5">ABONNÉS</Badge>
                </div>
                <div className="text-3xl font-bold text-white">{stats.totalSubscribers}</div>
                <div className="text-xs text-blue-100 mt-1">
                  Total · {stats.activeAssignments} actif{stats.activeAssignments > 1 ? 's' : ''}
                </div>
              </CardContent>
            </Card>

            <Card className="kpi-rise kpi-rise-3 relative overflow-hidden border-0 shadow-lg">
              <div className="absolute inset-0 bg-gradient-to-br from-amber-500 to-orange-600" />
              <CardContent className="relative p-5">
                <div className="flex items-center justify-between mb-2">
                  <div className="p-2 rounded-lg bg-white/20 backdrop-blur">
                    <TrendingUp className="w-5 h-5 text-white" />
                  </div>
                  <Badge className="bg-slate-900/70 text-white border border-white/30 text-[10px] font-bold tracking-wider px-2 py-0.5">MRR</Badge>
                </div>
                <div className="text-3xl font-bold text-white">{stats.monthlyRevenue.toLocaleString('fr-FR')}€</div>
                <div className="text-xs text-amber-100 mt-1">Revenus mensuels</div>
              </CardContent>
            </Card>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Répartition par type */}
            <Card className="shadow-sm border border-slate-200">
              <CardHeader className="border-b bg-gradient-to-r from-slate-50 to-slate-100">
                <CardTitle className="text-base flex items-center gap-2">
                  <div className="p-1.5 rounded-md bg-purple-100"><PieChart className="h-4 w-4 text-purple-600" /></div>
                  Répartition par Type de Tarification
                </CardTitle>
              </CardHeader>
              <CardContent className="p-6">
                <div className="space-y-4">
                  {stats.byType.length === 0 ? (
                    <div className="text-center py-6 text-slate-400 text-sm">Aucune donnée</div>
                  ) : stats.byType.map((type) => {
                    const TypeIcon = type.icon;
                    const percentage = stats.totalPlans > 0 ? Math.round((type.count / stats.totalPlans) * 100) : 0;
                    return (
                      <div key={type.value} className="space-y-2">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <div className={`p-2 rounded-lg ${type.bg}`}>
                              <TypeIcon className={`h-4 w-4 ${type.text}`} />
                            </div>
                            <span className="font-medium text-slate-700 text-sm">{type.label}</span>
                          </div>
                          <div className="flex items-center gap-2">
                            <span className="text-xl font-bold text-slate-900">{type.count}</span>
                            <Badge variant="outline" className="text-[10px] px-1.5 py-0">{percentage}%</Badge>
                          </div>
                        </div>
                        <div className="h-2 bg-slate-100 rounded-full overflow-hidden">
                          <div
                            className={`h-full bg-gradient-to-r ${type.gradient} rounded-full transition-all duration-700`}
                            style={{ width: `${percentage}%` }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </CardContent>
            </Card>

            {/* Top plans */}
            <Card className="shadow-sm border border-slate-200">
              <CardHeader className="border-b bg-gradient-to-r from-slate-50 to-slate-100">
                <CardTitle className="text-base flex items-center gap-2">
                  <div className="p-1.5 rounded-md bg-amber-100"><Award className="h-4 w-4 text-amber-600" /></div>
                  Top 5 Plans les Plus Populaires
                </CardTitle>
              </CardHeader>
              <CardContent className="p-6">
                <div className="space-y-4">
                  {plans.length === 0 ? (
                    <div className="text-center py-8 text-slate-400">
                      <Activity className="h-10 w-10 mx-auto mb-2 text-slate-300" />
                      <p className="text-sm">Aucune donnée disponible</p>
                    </div>
                  ) : plans
                    .slice()
                    .sort((a, b) => (b.subscribers_count || 0) - (a.subscribers_count || 0))
                    .slice(0, 5)
                    .map((plan, index) => {
                      const maxSubs = Math.max(...plans.map(p => p.subscribers_count || 0), 1);
                      const percentage = Math.round(((plan.subscribers_count || 0) / maxSubs) * 100);
                      const medalColor = index === 0 ? 'from-amber-400 to-yellow-500' : index === 1 ? 'from-slate-300 to-slate-400' : index === 2 ? 'from-orange-400 to-amber-600' : 'from-slate-200 to-slate-300';
                      return (
                        <div key={plan.id} className="space-y-2">
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3">
                              <div className={`w-8 h-8 rounded-lg bg-gradient-to-br ${medalColor} flex items-center justify-center text-white font-bold text-xs shadow-sm`}>
                                {index + 1}
                              </div>
                              <div className="min-w-0">
                                <div className="font-medium text-slate-800 text-sm truncate">{plan.nom}</div>
                                <div className="text-[11px] text-slate-500">{getPricingTypeConfig(plan.type_tarification).label}</div>
                              </div>
                            </div>
                            <div className="flex items-center gap-1.5">
                              <Users className="h-3.5 w-3.5 text-slate-400" />
                              <span className="font-bold text-slate-900">{plan.subscribers_count || 0}</span>
                            </div>
                          </div>
                          <div className="h-2 bg-slate-100 rounded-full overflow-hidden">
                            <div
                              className="h-full rounded-full transition-all duration-700"
                              style={{ width: `${percentage}%`, backgroundColor: plan.couleur }}
                            />
                          </div>
                        </div>
                      );
                    })}
                </div>
              </CardContent>
            </Card>
          </div>
        </TabsContent>
  );
};

export default GestionPlansAnalyticsTab;
